<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header py-4">
          <div class="row align-items-center">
            <div class="col-9 font-size-16" v-if="!item">Criar uma nova Propriedade</div>
            <div class="col-9 font-size-16" v-else>Editar uma Propriedade</div>
            <div class="col-3">
              <button
                type="button"
                class="btn btn-sm btn-info float-end"
                @click="$emit('handle2')"
              >Voltar</button>
            </div>
          </div>
        </div>
        <div class="card-body">
          <form @submit.prevent="onSubmit">
            <div class="row align-items-center">
              <div class="col-3">
                <div class="input-group input-group-outline mb-3">
                  <label class="form-label">*Nome</label>
                  <input type="text" v-model="propertie.name" class="form-control" />
                </div>
              </div>
              <div class="col-3">
                <div class="input-group input-group-outline mb-3">
                  <label class="form-label">*Alias</label>
                  <input type="text" v-model="propertie.alias" class="form-control" />
                </div>
              </div>
              <div class="col-3">
                <app-input-select
                  :options="defaultValues"
                  :disabled="Boolean(item)"
                  v-model="propertie.modelo"
                  label="*Tipo"
                  @input="checkFormFilled"
                  c_css
                />
              </div>
              <div class="col-3" v-if="isOption()">
                <app-input-text-add label="*Valor" c_css @input="addValue" />
              </div>
            </div>
            <div class="row align-items-center" v-if="Object.keys(propertie.values).length > 0">
              <div class="col-12">
                <label class="form-check-label mb-2">({{countValidValues()}}) Propriedade(s)</label>
                <div class="table-responsive">
                  <table class="table table-striped mb-0 table-bordered">
                    <thead>
                      <tr>
                        <th>Nome</th>
                        <th width="40">-</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(pro, index2) in propertie.values" v-bind:key="index2">
                        <td>{{pro.name}}</td>
                        <td>
                          <app-button-delete-confirm
                            @handle="removePropertie(pro.id);"
                            v-if="pro.status"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-6 mt-3">
                <button
                  type="submit"
                  class="btn btn-primary waves-effect waves-light"
                  :disabled="!isFormFilled"
                >Salvar</button>
                <span class="badge rounded-pill bg-danger m-1" v-if="message">*alterações não salvas</span>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AppInputSelect from "@/components/AppInputSelect/AppInputSelect.vue";
import AppInputTextAdd from "@/components/AppInputTextAdd/AppInputTextAdd.vue";
import AppButtonDeleteConfirm from "@/components/AppButtonDeleteConfirm/AppButtonDeleteConfirm.vue";
import { mapActions } from "vuex";
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    AppInputSelect,
    AppInputTextAdd,
    AppButtonDeleteConfirm
  },
  data() {
    return {
      isFormFilled: false,
      propertie: {
        name: null,
        alias: null,
        modelo: null,
        values: []
      },
      defaultValue: null,
      defaultValues: [
        { value: "1", text: "Texto" },
        { value: "2", text: "Número" },
        { value: "3", text: "E-mail" },
        { value: "4", text: "Telefone" },
        { value: "5", text: "URL" },
        { value: "6", text: "Seleção" },
        { value: "7", text: "Seleção multipla" },
        { value: "11", text: "Opção" },
        { value: "12", text: "Total" }
      ],
      temp: null,
      message: false,
      selected: {}
    };
  },
  computed: {
    alertMessage() {
      return "";
    },
    toggleActive() {
      return {
        active: this.isActive,
        "toggle-on": this.isActive,
        "toggle-off": !this.isActive
      };
    }
  },
  mounted() {
    if (this.item) {
      this.getPropertie();
    }
  },
  methods: {
    ...mapActions([
      "showMessage",
      "showLoader",
      "setLoaderTitle",
      "showBlockScreen"
    ]),
    countValidValues() {
      if (Object.keys(this.propertie.values).length === 0) {
        return 0;
      }
      return this.propertie.values.filter(item => !item.status === false)
        .length;
    },
    removePropertie(id) {
      this.propertie.values = this.propertie.values.map(item => {
        if (item.id === id) {
          return {
            ...item,
            status: false
          };
        }
        return item;
      });
    },
    isOption() {
      if (
        this.propertie.modelo === "6" ||
        this.propertie.modelo === "7" ||
        this.propertie.modelo === "11"
      ) {
        return true;
      }
      return false;
    },
    addValue(val) {
      if (this.propertie.values.some(value => value.name === val.toLowerCase()))
        return;
      const total = Object.keys(this.propertie.values).length;
      let data = {
        id: eval(total + 1),
        name: val.toLowerCase(),
        status: true
      };
      this.propertie.values.push(data);
    },
    getPropertie() {
      let original = JSON.parse(JSON.stringify(this.item));
      this.propertie.name = original.name;
      this.propertie.alias = original.old_id;
      this.propertie.modelo = original.propertie_type_id.toString();
      this.propertie.values = JSON.parse(original.values);
      this.checkFormFilled();
    },
    onSubmit() {
      let _this = this;
      _this.showLoader(true);
      const data = _this.propertie;

      console.log("data", data);
      let headers = {};
      if (_this.item && Object.keys(_this.item).length > 0) {
        headers = _this.$getAPIHeaders(
          "PATCH",
          `propertie/${_this.item.id}`,
          data
        );
      } else {
        headers = _this.$getAPIHeaders("POST", `propertie`, data);
      }
      this.axios(headers)
        .then(function(response) {
          _this.showLoader(false);
          _this.showMessage({
            title: response.data.message,
            css: "bg-success"
          });
          _this.onAction(response.data.data);
        })
        .catch(function(error) {
          _this.showLoader(false);
          _this.showMessage({
            title: error.response.data.message,
            text: _this.$root.$options.filters.objectError(
              error.response.data.errors
            ),
            css: "bg-danger"
          });
        });
    },
    onAction(data) {
      this.$emit("handle", data);
    },
    checkFormFilled() {
      this.isFormFilled =
        this.propertie.name !== null && this.propertie.modelo !== null;
    },
    addUser(id) {
      if (this.squad.users.some(user => user.id === id)) return;
      const temp = this.users.find(user => user.id === id);
      if (!temp) return;
      const user = {
        id: temp.id,
        name: temp.name,
        email: temp.email,
        pivot: {
          user_id: temp.id,
          is_admin: 0
        }
      };
      this.squad.users.push(user);
      this.message = true;
    },
    removeUser(id) {
      this.squad.users = this.squad.users.filter(u => u.id !== id);
      this.message = true;
    },
    createArrayPost(arr) {
      let ret = [];
      if (arr.length > 0) {
        for (const el of arr) {
          let temp = {};
          temp.user_id = el.id;
          temp.is_admin = el.pivot.is_admin;
          ret.push(temp);
        }
      }

      return ret;
    }
  }
};
</script>
<style scoped>
.avatar-xs {
  display: inline-block;
}
</style>